export default "__VITE_ASSET__BKlGa_hs__";